module.exports = __webpack_public_path__ + "static/media/circulo_9B9B9B.d56a9446.svg";